// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"fc34a7e1","412":"817eb2b6","866":"47cb5585"}[chunkId] + ".chunk.js";
};